export default "__VITE_ASSET__0DsapO4L__"